<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="dedication"><span>To my true love and husband, Dennis,</span></p>
<p class="center"><span>and</span></p>
<p class="center"><span>to Ed Gorman, who inspires me with his friendship and his outstanding novels and stories.</span></p>
<p class="center"><span>Ed, you’re a class act.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3dedication.vue?39b8ee5e